import { FC } from 'react';

import { ic_member_delete } from '.';
const MemberDeleteIcon: FC<{ width?: number }> = ({ width = 24 }) => {
  return <img src={ic_member_delete} width={width} alt="" />;
};

export default MemberDeleteIcon;
